import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { blogs } from "../Blog";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import Banner from "../../../components/layout/Banner";

/* ================= COLORS ================= */
const COLORS = {
  primary: "text-[#546E7A]", // dark
  primaryBg: "bg-[#546E7A]",
  accent: "text-[#D7A19E]",
  accentBg: "bg-[#D7A19E]",
  text: "text-[#4A5A64]",
  border: "border-[#C5B358]",
  divider: "bg-[#9BB2A3]",
  sectionBg: "bg-[#F9FBFA]",
  hoverAccent: "hover:bg-[#F1D6D4]",
};

const BlogList = () => {
  const blogsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);

  // Sort blogs by latest date
  const sortedBlogs = [...blogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const totalPages = Math.ceil(sortedBlogs.length / blogsPerPage);

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = sortedBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  return (
    <>
      {/* ================= SEO ================= */}
      <Helmet>
        <title>Blogs - Dr Vibha</title>
        <meta
          name="description"
          content="Read expert articles on women's health, pregnancy care, fertility, PCOS, gynecology treatments, and wellness tips by Dr Vibha."
        />
        <meta
          name="keywords"
          content="women health blog, pregnancy tips, fertility blog, gynecology articles, PCOS tips, Dr Vibha blog"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Header />

      <Banner
        title="Blogs"
        subtitle="Committed to Women's Health & Wellness"
        image="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg/1280px-A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg"
      />

      {/* ================= BLOG GRID ================= */}
      <section className={`${COLORS.sectionBg} py-20 px-6 md:px-16 lg:px-32`}>
        <div className="max-w-7xl mx-auto">

          {/* Heading */}
          <h2
            className={`text-3xl md:text-4xl font-bold ${COLORS.primary} text-center mb-14`}
          >
            Our Latest Blogs
          </h2>

          {/* Grid */}
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {currentBlogs.map((blog) => (
              <Link
                to={`/blogs/${blog.slug}`}
                key={blog.id}
                className="group bg-white rounded-2xl shadow-md overflow-hidden transition duration-300 hover:shadow-xl hover:-translate-y-2"
              >
                {/* Image */}
                <div className="overflow-hidden">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-56 object-cover group-hover:scale-110 transition duration-700"
                  />
                </div>

                {/* Content */}
                <div className="p-6">
                  <span className="text-xs text-gray-500">{blog.date}</span>

                  <h2
                    className={`text-lg font-semibold ${COLORS.primary} mt-2 mb-2 line-clamp-2`}
                  >
                    {blog.title}
                  </h2>

                  <p className={`text-sm ${COLORS.text} line-clamp-2 mb-4`}>
                    {blog.excerpt}
                  </p>

                  <span
                    className={`text-sm font-semibold ${COLORS.accent} hover:underline transition`}
                  >
                    Read More →
                  </span>
                </div>
              </Link>
            ))}
          </div>

          {/* ================= Pagination ================= */}
          <div className="flex justify-center mt-12 gap-3">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`px-4 py-2 rounded-md border transition ${
                  currentPage === i + 1
                    ? `${COLORS.accentBg} text-white`
                    : `bg-white ${COLORS.border} ${COLORS.primary} ${COLORS.hoverAccent}`
                }`}
              >
                {i + 1}
              </button>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default BlogList;